import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';
import useUser from 'Utilities/hooks/useUser';

export const useOptimizelyDealerEnquiryCombinedId = () => {
	const { dealerId } = useUser();
	const { id } = useVehicleData();

	return `${dealerId}-${id}`;
};
